import { render, staticRenderFns } from "./GroupSelection.vue?vue&type=template&id=0832cc10&"
import script from "./GroupSelection.vue?vue&type=script&lang=js&"
export * from "./GroupSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports